
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PortfolioItem,
  PortfolioVideo,
} from '../models';
import {
    PortfolioItemFromJSON,
    PortfolioItemToJSON,
    PortfolioVideoFromJSON,
    PortfolioVideoToJSON,
} from '../models';

export interface AddPhotoToPortfolioRequest {
    file: Blob;
    title?: string;
}

export interface AddVideoToPortfolioRequest {
    portfolioVideo: PortfolioVideo;
}

export interface DeletePortfolioItemRequest {
    id: string;
}

export interface UpdatePortfolioItemRequest {
    id: string;
    portfolioItem: PortfolioItem;
}

/**
 * 
 */
export class PortfolioApi extends runtime.BaseAPI {

    /**
     * Adds a photo to portfolio
          */
    async addPhotoToPortfolioRaw(requestParameters: AddPhotoToPortfolioRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PortfolioItem>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling addPhotoToPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['title'] != null) {
            formParams.append('title', requestParameters['title'] as any);
        }

        const response = await this.request<PortfolioItem>({
            path: `/profile/api/portfolio/photo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=PortfolioItemFromJSON(response._data); }
        return response;
    }

    /**
     * Adds a photo to portfolio
          */
    async addPhotoToPortfolio(requestParameters: AddPhotoToPortfolioRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PortfolioItem> {
        const response = await this.addPhotoToPortfolioRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Adds a video to portfolio
          */
    async addVideoToPortfolioRaw(requestParameters: AddVideoToPortfolioRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PortfolioItem>> {
        if (requestParameters['portfolioVideo'] == null) {
            throw new runtime.RequiredError(
                'portfolioVideo',
                'Required parameter "portfolioVideo" was null or undefined when calling addVideoToPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<PortfolioItem>({
            path: `/profile/api/portfolio/video`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioVideoToJSON(requestParameters['portfolioVideo']),
        }, initOverrides);

        if (response._data) { response._data=PortfolioItemFromJSON(response._data); }
        return response;
    }

    /**
     * Adds a video to portfolio
          */
    async addVideoToPortfolio(requestParameters: AddVideoToPortfolioRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PortfolioItem> {
        const response = await this.addVideoToPortfolioRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Deletes portfolio item
          */
    async deletePortfolioItemRaw(requestParameters: DeletePortfolioItemRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePortfolioItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/portfolio/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Deletes portfolio item
          */
    async deletePortfolioItem(requestParameters: DeletePortfolioItemRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePortfolioItemRaw(requestParameters, initOverrides);
    }

    /**
     * Gets portfolio items
          */
    async getPortfolioItemsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<PortfolioItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<PortfolioItem>>({
            path: `/profile/api/portfolio`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(PortfolioItemFromJSON);
        return response;
    }

    /**
     * Gets portfolio items
          */
    async getPortfolioItems(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<PortfolioItem>> {
        const response = await this.getPortfolioItemsRaw(initOverrides);
        return response._data;
    }

    /**
     * Updates portfolio item
          */
    async updatePortfolioItemRaw(requestParameters: UpdatePortfolioItemRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PortfolioItem>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePortfolioItem().'
            );
        }

        if (requestParameters['portfolioItem'] == null) {
            throw new runtime.RequiredError(
                'portfolioItem',
                'Required parameter "portfolioItem" was null or undefined when calling updatePortfolioItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<PortfolioItem>({
            path: `/profile/api/portfolio/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioItemToJSON(requestParameters['portfolioItem']),
        }, initOverrides);

        if (response._data) { response._data=PortfolioItemFromJSON(response._data); }
        return response;
    }

    /**
     * Updates portfolio item
          */
    async updatePortfolioItem(requestParameters: UpdatePortfolioItemRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PortfolioItem> {
        const response = await this.updatePortfolioItemRaw(requestParameters, initOverrides);
        return response._data;
    }

}
